const ViolationTypes = [
  { key: '1HourMarginOnRest', label: '1 Hour<br />Margin On Rest' },
  { key: 'CourseRequest', label: 'Course Request' },
  { key: 'Maximum1ReportingPerCalendarDay', label: 'Max 1 Reporting<br />Per Calendar Day' },
  { key: 'Maximum2DaysWith4Legs', label: 'Max 2 Days<br />With 4 Legs' },
  { key: 'Maximum111h30DutyIn48h', label: 'Max 111h30 Duty<br />In 48h' },
  { key: 'Maximum213h00DutiesIn5Days', label: 'Max 213h00 Duties<br />In 5 Days' },
]
export default ViolationTypes
